import React from "react";
import { motion } from "framer-motion";
import { LogIn, UserX } from "lucide-react";

const DashboardAccessMessage = ({ isAuthenticated }) => {
  return (
    <div className="container mx-auto py-10 px-4 text-center min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-background to-secondary/5">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="p-8 rounded-xl bg-card shadow-2xl max-w-md w-full"
      >
        {isAuthenticated ? (
          <UserX className="h-12 w-12 text-destructive mx-auto mb-4" />
        ) : (
          <LogIn className="h-12 w-12 text-primary mx-auto mb-4" />
        )}
        <h1 className="text-2xl font-bold text-foreground mb-3">
          {isAuthenticated ? "Access Denied" : "Accessing Dashboard"}
        </h1>
        <p className="text-muted-foreground">
          {isAuthenticated
            ? "This dashboard is for sellers only. Verifying account type..."
            : "Please log in or sign up to continue."}
        </p>
        {/* Optional: Add a button to go home or open login dialog if not authenticated */}
        {/* {!isAuthenticated && <Button className="mt-6" onClick={() => openAuthDialog(true)}>Login / Sign Up</Button>} */}
      </motion.div>
    </div>
  );
};

export default DashboardAccessMessage;
